import * as React from "react";
import type { SVGProps } from "react";
const SvgToggleRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M8 6h8V4H8zm8 0a6 6 0 0 1 6 6h2a8 8 0 0 0-8-8zm6 6a6 6 0 0 1-6 6v2a8 8 0 0 0 8-8zm-6 6H8v2h8zm-8 0a6 6 0 0 1-6-6H0a8 8 0 0 0 8 8zm-6-6a6 6 0 0 1 6-6V4a8 8 0 0 0-8 8zm16 0a2 2 0 0 1-2 2v2a4 4 0 0 0 4-4zm-2 2a2 2 0 0 1-2-2h-2a4 4 0 0 0 4 4zm-2-2a2 2 0 0 1 2-2V8a4 4 0 0 0-4 4zm2-2a2 2 0 0 1 2 2h2a4 4 0 0 0-4-4z"
    />
  </svg>
);
export default SvgToggleRight;
